(function () {
  document.querySelectorAll('.tg').forEach(function (root) {
    // Daily ritual: highlight the step in the middle of the screen and crossfade its photo
    var rit = root.querySelector('[data-tg-ritual]');
    if (rit) {
      var steps = rit.querySelectorAll('.tg-ritual__step');
      var imgs = rit.querySelectorAll('.tg-ritual__img');
      var clock = rit.querySelector('[data-tg-clock]');
      var prog = rit.querySelector('[data-tg-prog]');
      var setActive = function (i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
        if (clock) clock.textContent = steps[i].getAttribute('data-time');
        if (prog) prog.style.width = ((i + 1) / steps.length * 100) + '%';
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) setActive(Array.prototype.indexOf.call(steps, e.target));
          });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        steps.forEach(function (s) { io.observe(s); });
      }
    }

    // Review cards: arrow buttons
    var track = root.querySelector('[data-tg-track]');
    if (track) {
      var step = function () { var c = track.querySelector('.tg-rcard'); return c ? c.getBoundingClientRect().width + 14 : 320; };
      var prev = root.querySelector('[data-tg-prev]'), next = root.querySelector('[data-tg-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    // Reveal the review score card (histogram bars) even if the main script has already run
    var score = root.querySelector('.tg-rev__score');
    if (score && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); so.unobserve(e.target); } }); }, { threshold: 0.2 });
      so.observe(score);
    } else if (score) { score.classList.add('is-in'); }
  });
})();
